import * as React from 'react'
import {
  Create,
  SimpleForm,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  NumberInput,
  TopToolbar,
  ListButton,
  Toolbar,
  SaveButton,
} from 'react-admin'

import { useGetIdentity } from 'react-admin'
import * as PropTypes from 'prop-types'
import { useTranslate } from 'ra-core'
import { Typography, Box } from '@material-ui/core'
import { required } from 'react-admin'

const CoregCreateActions = ({ identity, basePath }) => {
  let countryBasePath = ''
  if (identity.role !== 'admin') {
    countryBasePath = `${basePath}?filter={"country":"${identity.country}"}`
  }
  return (
    <TopToolbar>
      <ListButton basePath={countryBasePath} />
    </TopToolbar>
  )
}

CoregCreateActions.propTypes = {
  basePath: PropTypes.any,
  identity: PropTypes.any,
}

const CoregsCreateToolbar = props => {
  const translate = useTranslate()
  return (
    <Toolbar {...props}>
      <SaveButton
        label={translate('surveys.actions.create_coregs')}
        redirect="coregs"
      />
    </Toolbar>
  )
}

const CoregsCreate = props => {
  const { identity, loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  const country = identity.country
  const questionSource = 'label.' + country.toLowerCase()
  return (
    <Create actions={<CoregCreateActions identity={identity} />} {...props}>
      <SimpleForm toolbar={<CoregsCreateToolbar />}>
        <Box mb={2}>
          <Typography variant="body2" color="textSecondary">
            Configura la relacion entre pregunta y campana de corregistro.
          </Typography>
        </Box>
        <ReferenceInput
          translateChoice={false}
          label="Question"
          source="questionId"
          reference="questions"
        >
          <SelectInput optionText={questionSource} validate={[required()]} />
        </ReferenceInput>
        <NumberInput
          label="CD Affiliate"
          source="cdAffiliateId"
          validate={[required()]}
        />
        <NumberInput
          label="CD Campaign"
          source="cdCampaignId"
          validate={[required()]}
        />
        <BooleanInput source="status" defaultValue={false} />
        <SelectInput
          fullWidth
          source="country"
          choices={[
            { id: 'ES', name: 'ES' },
            { id: 'IT', name: 'IT' },
            { id: 'FR', name: 'FR' },
            { id: 'EN', name: 'EN' },
          ]}
          validate={[required()]}
        />
      </SimpleForm>
    </Create>
  )
}

export default CoregsCreate
